import React, { useEffect, useState } from "react";
import Layout from "../../components/shared/Layout/Layout";
import API from "../../services/API";
import { toast } from "react-toastify";
import moment from "moment";

const Donar = () => {
  const [data, setData] = useState([]);

  const getDonars = async () => {
    try {
      const { data } = await API.get("/inventory/get-donar");
      if (data?.success) {
        setData(data?.donars);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  useEffect(() => {
    getDonars();
  }, []);
  return (
    <Layout>
      <h3 className="mx-auto donar-heading">
        Donar Details{" "}
        <i
          className="fa-solid fa-hand-holding-medical fa-flip-horizontal"
          style={{ color: "#000000s" }}
        />
      </h3>
      <div className="container">
        <div className="container donar-data">
          <table className="table table-hover">
            <thead>
              <tr className="heading-fixed">
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col">Phone</th>
                <th scope="col">Date & Time</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((record) => (
                <tr key={record._id}>
                  <td>{record.name || record.organisationName + " (ORG)"}</td>
                  <td>{record.email}</td>
                  <td>{record.phone}</td>
                  <td>
                    {moment(record.createdAt).format("DD/MM/YYYY hh:mm A")}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
};

export default Donar;
